import React from "react";

import ImageOverlayEditor from "../components/explore/ImageUpload";

const Explore = () => {
  return (
    <div className="mt-10 mb-10 max-w-3xl mx-auto">
      <ImageOverlayEditor></ImageOverlayEditor>
    </div>
  );
};

export default Explore;
